"use client";

import { decodeSku, type DecodedPart } from "@/lib/utils/decodeSku";

interface ProductSkuDecodedProps {
    sku: string;
    titleHide?: number;
}

export default function ProductSkuDecoded({
                                              sku,
                                              titleHide = 0,
                                          }: ProductSkuDecodedProps) {
    const decoded = decodeSku(sku);

    if (!decoded.parts.length) {
        return null;
    }

    const getDisplayValue = (item: DecodedPart) => {
        const key = item.key.toUpperCase();

        const countMatch = key.match(/^(\d+)/);

        if (countMatch) {
            return {
                title: item.value.replace(/^\d+\s*/, ""),
                value: countMatch[1],
                sub: item.sub,
            };
        }

        return {
            title: item.value,
            value: key,
            sub: item.sub,
        };
    };

    return (
        <div className="mt-1 mb-3 w-full">
            <div className={`grid grid-cols-2 gap-1.5 ${titleHide === 0 ? "sm:grid-cols-3" : "sm:grid-cols-3 lg:grid-cols-6"}`}>
                {decoded.parts.map((item, index) => {
                    const display = getDisplayValue(item);

                    return (
                        <div
                            key={index}
                            className="rounded-xl bg-gray-100/70 p-1.5 py-5 text-center"
                        >

                                <div className="text-sm text-gray-500 mb-2">
                                    {display.title}
                                </div>


                            {!item.hideValue && (
                                <div className="text-xl font-bold text-gray-900 ltr">
                                    {display.value}
                                </div>
                            )}

                            <div
                                className={`mt-2 ${
                                    item.hideValue
                                        ? "text-xl font-bold text-gray-900"
                                        : "text-xs text-gray-500"
                                } ltr`}
                            >
                                {item.sub}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}